import { BaseConnector } from '@/connectors/base.connector';
import { Bundle } from '@/connectors/bundles/bundle.model';
import { BundleStatistics } from '@/connectors/bundles/bundle-statistics.model';

export class BundlesConnector extends BaseConnector {
  constructor() {
    super('bundles');
  }

  async getAll(): Promise<Bundle[]> {
    return (await this.get<Bundle[]>()).result;
  }

  async getById(id: string): Promise<Bundle> {
    return (await this.get<Bundle>(`/${id}`)).result;
  }

  async getStatisticsForBundleId(id: string): Promise<BundleStatistics> {
    return (await this.get<BundleStatistics>(`/${id}/statistics`)).result;
  }
}
